import * as S from './VideoBlock.styled'
import * as C from './CookieVideoPreferences.styled'

interface CookieVideoPreferencesProps {
  thumbnailURL?: string
}

const CookieVideoPreferences = ({ thumbnailURL }: CookieVideoPreferencesProps) => {
  return (
    <S.PlayerWrapper>
      <C.CookieVideoPreferencesWrapper>
        <C.CookieVideoPreferencesImage
          src={thumbnailURL || ''}
          alt="Video thumbnail"
        />
        <C.CookieVideoPreferencesText>
          You need to accept media cookies to view this video.
        </C.CookieVideoPreferencesText>
        <C.CookieVideoPreferencesButton
          onClick={() => {
            const consentModal = document.querySelector(
              '[data-cc="show-consentModal"]'
            )
            if (consentModal instanceof HTMLElement) {
              consentModal.click()
            }
          }}
        >
          Cookie Preferences
        </C.CookieVideoPreferencesButton>
      </C.CookieVideoPreferencesWrapper>
    </S.PlayerWrapper>
  )
}

export default CookieVideoPreferences